export const preanalyticsProducts = {
  'prd-eugenio': {
    key: 'eugenio',
    primaryMedia: '/media/source/images/Eugenio-Esamed-1.png',
    gallery: [
      '/media/source/images/EugenioAperto-scaled.jpg',
      '/media/source/images/Eugenio-1940-scaled.jpg',
      '/media/source/images/Eugenio-1974-scaled.jpg',
    ],
  },
  'prd-flashbot-pudu-smanno-camminatore': {
    key: 'flashbot',
    primaryMedia: '/media/source/images/pudu-smanno-1.png',
  },
  'prd-portaprovette': {
    key: 'tubeRack',
    primaryMedia: '/media/source/images/rack-esamed-1.png',
    secondaryMedia: '/media/source/images/rack-rosso-3.png',
  },
  'prd-tipos-olpaso': {
    key: 'tipos',
    primaryMedia: '/media/source/images/TIPOS-1.png',
  },
  'prd-tt-2000-s-endmed': {
    key: 'tt2000',
    primaryMedia: '/media/source/images/TT2000S.png',
  },
  'prd-tt-2000-s-iqvision-endmed': {
    key: 'tt2000Iq',
    primaryMedia: '/media/source/images/TT2000S_IQ.png',
  },
} as const

export type PreanalyticsProductId = keyof typeof preanalyticsProducts
export type PreanalyticsProductKey = (typeof preanalyticsProducts)[PreanalyticsProductId]['key']

export function isPreanalyticsProductId(id: string): id is PreanalyticsProductId {
  return id in preanalyticsProducts
}
